import { useMemo } from 'react';
import { generateContactKey, getContactKeyType, extractContactKeyValue } from '@/utils/contactKey';

interface CallAction {
  id: string;
  call_id: string;
  campaign_id: string;
  prospect_id: string;
  type: string;
  confidence: number;
  phrase: string | null;
  action_data: any;
  processed: boolean;
  created_at: string;
  campaign?: {
    name: string;
  };
  mode?: string;
}

interface GroupedContacts {
  [contactKey: string]: CallAction[];
}

export function useGroupedActions(actions: CallAction[]): GroupedContacts {
  return useMemo(() => {
    const grouped: GroupedContacts = {};

    for (const action of actions) {
      // RULE: 1 call = 1 card, period. Group strictly by call_id
      const contactKey = `call:${action.call_id}`;
      
      if (!grouped[contactKey]) {
        grouped[contactKey] = [];
      }
      
      grouped[contactKey].push(action);
    }

    // Sort actions within each group by created_at (newest first)
    Object.keys(grouped).forEach(key => {
      grouped[key].sort((a, b) => 
        new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
      );
    });

    return grouped;
  }, [actions]);
}

// Re-export the centralized utilities
export { getContactKeyType, extractContactKeyValue };